import mondaySdk from 'monday-sdk-js'
import axios from 'axios'

const monday = mondaySdk()

const domain = import.meta.env.PROD ? 'https://esl-okr-management-production.up.railway.app' : ''

async function getUserBoards(userDomain, sessionToken) {
  if (import.meta.env.PROD) {
    const boardRelations = await axios.get(`${domain}/api/monday/${userDomain}`, {
      headers: {
        Authorization: `Bearer ${sessionToken}`,
      },
    })
    return boardRelations
  } else {
    const boardRelations = await axios.get(`${domain}/api/monday/${userDomain}`, {
      headers: {
        Authorization: `Bearer ${sessionToken}`,
      },
    })
    return boardRelations
  }
}

async function add(mainBoard, subBoards, userId, userDomain, isMulti, sessionToken) {
  const relation = {
    relation: {
      mainBoard,
      subBoards,
      userId,
      userDomain,
      isMulti,
    },
  }
  try {
    const newRelation = await axios.post(`${domain}/api/monday/add`, relation, {
      headers: {
        Authorization: `Bearer ${sessionToken}`,
      },
    })
    return newRelation.data
  } catch (err) {
    console.log('file: boardService.js:45 -> err:', err)
    throw err
  }
}

async function update(mainBoard, subBoards, userId, _id, userDomain, isMulti, sessionToken) {
  const relation = {
    relation: { mainBoard, subBoards, userId, _id, userDomain, isMulti },
  }
  try {
    await axios.post(
      `${domain}/api/monday/update`,
      { relation },
      {
        headers: {
          Authorization: `Bearer ${sessionToken}`,
        },
      }
    )
    return relation.relation
  } catch (err) {
    console.log('file: boardService.js:66 -> err:', err)
    throw err
  }
}

async function createNewItemWebHook(boardId, columnId, endpoint = 'createGroup') {
  try {
    const mutation = `
    mutation{
      create_webhook (board_id:${boardId}, url:${JSON.stringify(domain + '/' + endpoint)}, event:change_specific_column_value, config: ${JSON.stringify(
      JSON.stringify({
        columnId: columnId,
      })
    )}){
            id
            board_id
          }
        }`
    const res = await monday.api(mutation)
    console.log('file: boardService.js:94 -> res:', res)

    return Number(res.data?.create_webhook?.id)
  } catch (err) {
    console.log('file: boardService.js:89 -> err:', err)
  }
}

async function deleteWebhooks(webhookId) {
  try {
    const mutation = `
    mutation {
      delete_webhook ( id:${Number(webhookId)}) {
        id
        board_id
      }
    }
    `
    await monday.api(mutation)
  } catch (err) {
    console.log('file: boardService.js:119 -> err:', err)
    console.log('Webhook not deleted. Proceeding without deletion.')
  }
}

async function createMirrorWebHook(boardId, endpoint, event, webhookName) {
  try {
    const mutation = `mutation{
      create_webhook (board_id:${boardId}, url:${JSON.stringify(domain + '/' + endpoint)}, event:${event}){
          id
          board_id
        }
      }`
    const res = await monday.api(mutation)
    console.log('file: boardService.js:122 -> res:', res)

    return { [webhookName]: res.data?.create_webhook?.id, subBoard: boardId, event }
  } catch (err) {
    console.log(`createMirrorWebHook -> err`, err)

    throw err
  }
}

async function matchGroupAndItemNameWebHook(boardId) {
  try {
    const mutation = `mutation{
      create_webhook (board_id:${boardId}, url:${JSON.stringify(domain + '/matchGroupAndItemName')}, event:change_name){
          id
          board_id
        }
      }`
    const res = await monday.api(mutation)
    return Number(res.data?.create_webhook?.id)
  } catch (err) {
    console.log(`createMirrorWebHook -> err`, err)

    throw err
  }
}

async function deleteRelation(relation, sessionToken, setCountDeletion) {
  await axios.delete(`${domain}/api/monday/deleteRelation/${relation._id}`, {
    headers: {
      Authorization: `Bearer ${sessionToken}`,
    },
  })

  const mainWebhookId = relation.mainBoard.mainWebhook
  // Delete Create Group Webhook
  await deleteWebhooks(Number(mainWebhookId))

  // Delete Match Group And Name Webhook
  if (relation.mainBoard.matchGroupAndItemNameWebHookId) await deleteWebhooks(Number(relation.mainBoard.matchGroupAndItemNameWebHookId))
  const subWebhooks = relation.subBoards.map((board) => board?.subWebhook)
  const webhookIds = [relation.mainBoard.mainWebhook, relation.mainBoard.matchGroupAndItemNameWebHookId, ...subWebhooks]
  try {
    console.time('deleting')
    for (let i = 0; i < webhookIds?.length; i++) {
      const webhookId = webhookIds[i]
      await deleteWebhooks(Number(webhookId))
      setCountDeletion(i)
    }
    console.timeEnd('deleting')
  } catch (err) {
    console.log('file: boardService.js:171 -> err:', err)
    throw err
  }
}

export default {
  getUserBoards,
  add,
  update,
  update,
  createNewItemWebHook,
  createMirrorWebHook,
  matchGroupAndItemNameWebHook,
  deleteRelation,
  deleteWebhooks,
}
